import { requestWithToken } from '../../utilities/request';
const path = '/api/private';
const fieldPath = '/api/private/fields';

/**
 * 現場連携中サービス一覧取得API
 * @param {number} fieldId 現場ID
 * */
const list = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: fieldPath.concat(`/${fieldId}/field_integration_service_uses/list`),
  });
};

/**
 * 外部連携サービス一覧取得API
 * */
const fetchIntegrationService = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: path.concat(`/integration_service/list`),
    params: { field_id: fieldId },
  });
};

/**
 * 顔認証機器登録確認API
 * @param {number} fieldId 現場ID
 * @param {number} integrationServiceId 外部連携サービスID
 * */
const confirmIntegrationServiceRegistration = (
  fieldId,
  integrationServiceId
) => {
  return requestWithToken(
    {
      method: 'GET',
      url: fieldPath.concat(
        `/${fieldId}/check_face_image_uses/${integrationServiceId}`
      ),
    },
    false,
    false
  );
};

/**
 * 連携サービス関連のAPI群
 * */
export const IntegrationApi = {
  list,
  fetchIntegrationService,
  confirmIntegrationServiceRegistration,
};

export default IntegrationApi;



// WEBPACK FOOTER //
// ./src/services/integration/IntegrationApi.js